<template>
  <q-card style="min-width: 560px">
    <q-card-section class="text-center bg-primary">
      <div class="text-h6 text-weight-medium text-white">Select a carrier</div>
    </q-card-section>
    <q-separator />
    <q-card-section>
      <q-input
        class="q-mb-sm"
        dense
        placeholder="Seach"
        v-model.lazy="carrierSearch"
        @input="handleSearchInput"
      >
        <template v-slot:prepend>
          <q-icon name="search" />
        </template>
      </q-input>
      <q-list bordered class="border-black">
        <q-item>
          <q-item-section class="text-bold text-center">
            Carrier Name
          </q-item-section>
          <q-item-section class="text-bold text-center">
            MC Number
          </q-item-section>
          <q-item-section class="text-bold text-center">
            Location
          </q-item-section>
          <q-item-section class="text-bold text-center">#</q-item-section>
        </q-item>
      </q-list>
      <q-scroll-area style="height: 54vh" @scroll="handleScroll">
        <q-list bordered separator dense>
          <q-item
            v-for="(carrier, index) in carrierList"
            :key="carrier.id"
            :class="{'bg-grey-1':index%2==1}"
          >
            <q-item-section class="text-center text-bold">
              {{ carrier.companyName }}
            </q-item-section>
            <q-item-section class="text-center">
              {{ carrier.mcNumber }}
            </q-item-section>
            <q-item-section class="text-center">
              {{ carrier.city }}, {{ carrier.state }},{{ carrier.zipcode }}
            </q-item-section>
            <q-item-section class="text-center">
              <q-btn
                dense
                label="Select"
                color="primary"
                @click="$emit('select', carrier)"
              ></q-btn>
            </q-item-section>
          </q-item>
        </q-list>
      </q-scroll-area>
    </q-card-section>
    <q-separator />
    <q-card-actions align="right">
      <q-btn label="Add Carrier" color="primary" @click="$emit('add')" />
    </q-card-actions>
  </q-card>
</template>
<script>
import graphql from '@client/graphql';

export default {
  name: 'AppDispatchToCarrierDialogCarrierList',
  apollo: {
    carriers: {
      query: graphql.queries.getCarriers,
      variables() {
        return {
          search: this.carrierSearch,
          cursor: this.pageCursor,
          sortBy: 'NAME_ASC'
        };
      },
      watchLoading(isLoading) {
        this.loading = isLoading;
      },
      result(result) {
        if (result.loading) return;

        this.carrierList = this.carrierList.concat(result.data.carriers.data);

        this.nextPage = this.pageCursor.page + 1;
      },
      fetchPolicy: 'network-only'
    }
  },
  data() {
    return {
      carrierSearch: '',
      pageCursor: {
        page: 0,
        size: 50
      },
      nextPage: 1,
      loading: false,
      carrierList: []
    };
  },
  methods: {
    handleSearchInput() {
      this.pageCursor = {
        page: 0,
        size: 50
      };
      this.carrierList = [];
    },
    handleScroll(source) {
      if (source.verticalPercentage === 1) {
        this.pageCursor = {
          page: this.nextPage,
          size: 50
        };
      }
    }
  }
};
</script>
